import type { ApiClient } from '@prismo-io/schemas';

export const fetchSearchUsers = async (
  client: ApiClient,
  term: string | null
) => {
  // TODO: Penser à gerer les comptes privé et les accès PRISMO
  const baseQuery = client
    .from('users')
    .select(
      `
    id,
    url,
    full_name,
    email
    `
    )
    .eq('is_private', false)
    .limit(50);

  if (!term) {
    const { data } = await baseQuery;

    return data || [];
  }

  const { data } = await baseQuery
    .or(
      `first_name.ilike.%${term}%,last_name.ilike.%${term}%,email.ilike.%${term}%`
    )
    .limit(50);

  return data || [];
};
